import { Injectable } from "@angular/core"
import { Apollo } from "apollo-angular"
import { DocumentNode } from "graphql"
import gql from "graphql-tag"
import { Observable } from "rxjs"
import { ApolloQueryResult } from "apollo-client"
import { SubscriptionState } from "src/types"

export type AdminUploadData = {
  customer: AdminUploadCustomer
  contentTypes: AdminUploadContentType[]
}

export type AdminUploadCustomer = {
  id: number
  state: SubscriptionState
  multipass: boolean
  plan: {
    id: number
    code: string
    words: number
  }
  extraPurchases: AdminUploadContentType[]
}

export type AdminUploadContentType = {
  id: number
  code: string
  name: string
  wordMin: number
  wordMax: number
}

const AdminUploadQuery: DocumentNode = gql`
  query KeywordsPageQuery($customerId: ID!) {
    customer(id: $customerId) {
      id
      state
      multipass
      plan {
        id
        code
        words
      }
      extraPurchases {
        id
        extra {
          id
          code
        }
        purchasedAt
      }
    }
    contentTypes {
      id
      code
      name
      wordMin
      wordMax
    }
  }
`

@Injectable()

export class AdminUploadQueries {

  constructor(private apollo: Apollo) { }

  mainQuery(customerId: number): Observable<ApolloQueryResult<AdminUploadData>> {
    return this.apollo.watchQuery<AdminUploadData>({
      query: AdminUploadQuery,
      variables: { customerId },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network'
    }).valueChanges
  }

  guardQuery(): Observable<ApolloQueryResult<{currentUser: {id: number, adminImpersonating: boolean}}>> {
    return this.apollo.query<{currentUser: {id: number, adminImpersonating: boolean}}>({
      query: gql`
        query {
          currentUser {
            id
            adminImpersonating
          }
        }
      `
    })
  }
}
